// extracted by mini-css-extract-plugin
export default {"reservationsContainer":"ReservationsPage_reservationsContainer__1bw8O"};